import { render } from "./UsersFilter.vue?vue&type=template&id=2dec2018&scoped=true"
import script from "./UsersFilter.vue?vue&type=script&lang=js"
export * from "./UsersFilter.vue?vue&type=script&lang=js"

import "./UsersFilter.vue?vue&type=style&index=0&id=2dec2018&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dec2018"]])

export default __exports__